import { ClientType } from 'src/app/enums/client.enum';
import { IClient } from './client.inteface';
import { IITEDClient } from './iited-client';
import { IWSAClient } from './iwsa-client';

/**
* Client Factory
* Factory class responsible for creating client instances
*/
export class ClientFactory {
    private static instances: Map<string, IClient> = new Map();

    /**
     * Creates or returns cached client instance based on client type
     * @param clientType - The type of client to create
     * @returns IClient instance
     */
    static createClient(clientType: string): IClient {
        // Return cached instance if exists
        if (this.instances.has(clientType)) {
            return this.instances.get(clientType)!;
        }

        let client: IClient;

        switch (clientType.toLowerCase()) {
            case ClientType.IITED:
                client = new IITEDClient();
                break;
            // case ClientType.IWSA:
            //     client = new IWSAClient();
            //     break;
            default:
                throw new Error(`Unknown client type: ${clientType}`);
        }

        // Cache the instance
        this.instances.set(clientType, client);
        return client;
    }

    /**
     * Clear cached instances (useful for testing)
     */
    static clearCache(): void {
        this.instances.clear();
    }
}